import React, { useMemo } from 'react';
import type { InterstateOnChangeCallback } from '@interstate/components/InterstateEvents';
import type { SelectInputEventValue } from '@interstate/components/SelectInput';

import { Dropdown } from '@makemydeal/dr-shared-components';
import { getStateCodesSelectInputValues } from '@makemydeal/dr-shared-ui-utils';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

import { useIsLenderFieldDisabled } from '../../hooks';
import { LENDER_STATE } from '../../constants';
import { useLenderAddressField } from './hooks/useLenderAddressField';

const LenderStateField = () => {
    const { lenderAddress, updateField } = useLenderAddressField();
    const storedValue = lenderAddress?.state ?? '';
    const isDisabled = useIsLenderFieldDisabled();

    const stateOptions = useMemo(getStateCodesSelectInputValues, []);

    const handleChange: InterstateOnChangeCallback<SelectInputEventValue> = (event) => {
        const nextValue = event.target.value ?? '';
        if (nextValue === storedValue) return;
        updateField('state', nextValue);
    };

    return (
        <Dropdown
            size="sm"
            id="LenderStateField"
            data-testid="lender-state"
            label={LENDER_STATE}
            name="lender-state"
            onChange={handleChange}
            value={storedValue}
            options={stateOptions}
            disabled={isDisabled}
            allowRemoval={true}
            selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
        />
    );
};

export default LenderStateField;
